<template>
  <div>
    <v-layout row wrap v-for="field in fields" :key="field.key">
      <v-flex xs12 sm6 lg4>
        <v-subheader>{{field.header}}</v-subheader>
      </v-flex>
      <v-flex xs12 sm6 lg8>
        <v-switch
          v-if="field.type === Boolean"
          :label="formData[field.key] ? 'Activated' : 'Deactivated'" 
          v-model="formData[field.key]"
          :false-value="false"
          :true-value="true"
        ></v-switch>

        <v-text-field
          v-else-if="field.type === String"
          v-model="formData[field.key]"
          :label="field.label"
          :hint="field.hint"
          :suffix="field.suffix"
          @change="emitChanged()"
        ></v-text-field>

        <v-select
          v-else-if="field.type === 'Select'"
          :label="field.label"
          v-model="formData[field.key]"
          :items="['Daily', 'Weekly', 'Monthly']"
        ></v-select>

        <v-select
          v-else-if="field.type === 'Select-Multiple'"
          v-model="formData[field.key]"
          :label="field.label"
          :items="retrunReasonsList"
          multiple
        ></v-select>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    fields: {
      type: Array,
      required: true
    },
    inputFormData: {
      type: Object,
      required: true
    }
  },

  watch: {
    formData: {
      handler: function(val) {
        let changed = false

        Object.keys(this.formData).forEach(field => {
          if (val[field] !== this.inputFormData[field]) {
            changed = true
          }
        })

        if (changed) {
          this.emitChanged()
        }
      },
      deep: true
    }
  },

  data() {
    return {
      formData: Object.assign({}, this.inputFormData),
      retrunReasonsList: [
        'Did not like the article',
        'Article does not fit',
        'Inadequate quality',
        'Ordered by mistake',
        'Several variants ordered to choose from',
        'Item defective or damaged',
        'Wrong article delivered',
        'Delivery time was too long',
        'Item does not match the description',
        'Found better price',
        'No longer needed',
        'Other reason',
        'No reason specified',
        'Custom reason 1',
        'Custom reason 2',
        'Custom reason 3',
        'Custom reason 4',
        'Custom reason 5'
      ]
    }
  },

  methods: {
    emitChanged() {
      const payload = {}

      Object.keys(this.formData).forEach(key => {
        payload[key] = this.formData[key]
      })

      this.$emit('formDataChanged', payload)
    }
  }
}
</script>



// WEBPACK FOOTER //
// IsrsSettingsDialog.vue?392cfb86